/**
 * Roles the API can put on IGlimpseUser.roles. A user is expected to carry exactly one
 * of them — the array shape is historical.
 */
export type GlimpseRole = 'Administrator' | 'Auditor' | 'Customer';

/** Most privileged first: the order we fall back on if a user somehow ends up with several roles. */
const rolePriority: GlimpseRole[] = ['Administrator', 'Auditor', 'Customer'];

/**
 * Picks the single role to report for a user. Unknown roles are passed through rather than
 * dropped, so a role added on the backend still shows up in analytics before this list catches up.
 */
export function resolvePrimaryRole(roles: string[]): string | null {
  if (!roles || !roles.length) return null;

  return rolePriority.find(role => roles.includes(role)) ?? roles[0];
}
